import { createAsyncThunk } from '@reduxjs/toolkit';
import LoqateFindService from '../services/LoqateFindService/LoqateFindService';
import Config from '../config/config';
import { LoqateFindResponse } from '../services/LoqateFindService/LoqateFindService.types';

export const findAddress = createAsyncThunk<
  LoqateFindResponse,
  { query: string; province?: string; container?: string }
>('address/find', async ({ query, province, container }) => {
  const requestData = {
    Key: Config.LOQATE_API_KEY,
    Text: query,
    Container: container ?? '',
    IsMiddleware: false,
    Origin: province ?? '',
    Countries: 'CA',
    Limit: '7',
    Bias: true,
    Language: 'en-us',
  };
  return await LoqateFindService.loqateFind({
    pathParams: {},
    data: requestData,
  });
});
